/**
 * Signal to the underlying logic what version of the public component API
 * of the Data Grid is exposed.
 */
export enum GridSignature {
  DataGrid = 'DataGrid',
  DataGridPro = 'DataGridPro',
  DataGridPremium = 'DataGridPremium',
}
